import {Tab, TabsNavigation, Text} from '@/components-v2'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'
import {useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {ProductListTabContent} from './ProductListTabContent/ProductListTabContent'

// Countries allowed to see the Combo List tab when GrowthBook has no override configured.
const DEFAULT_COMBO_LIST_COUNTRIES = ['MX', 'US']

const ComboListTabContent = () => (
  <div className="flex flex-col gap-3">
    <Text headingLevel={5}>Combo List</Text>
    <Text>Combo List content coming soon.</Text>
  </div>
)

const PRODUCT_LIST_TABS = [
  {label: 'Product List', component: ProductListTabContent, icon: 'storefront'},
  {label: 'Combo List', component: ComboListTabContent, icon: 'person'},
]

export const ProductListPage = () => {
  const countryCode = useSelector(selectCountryCode)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const comboListCountriesFeature = useFeatureValue(growthBookFeatureFlags.AllowedCountriesForComboList)
  const allowedComboListCountries = comboListCountriesFeature?.allowedCountriesList ?? DEFAULT_COMBO_LIST_COUNTRIES
  const isComboListSupported = allowedComboListCountries.includes(countryCode)

  const tabs = useMemo(
    () => (isComboListSupported ? PRODUCT_LIST_TABS : PRODUCT_LIST_TABS.filter(tab => tab.label !== 'Combo List')),
    [isComboListSupported]
  )

  const activeTabIndex = Math.min(selectedTabIndex, tabs.length - 1)
  const SelectedTabComponent = tabs[activeTabIndex]?.component ?? ProductListTabContent

  return (
    <div className="flex flex-col gap-6" data-testid="new-theme-product-list-page">
      <Text headingLevel={4}>Products</Text>
      <TabsNavigation selectedIndex={activeTabIndex} onUpdate={setSelectedTabIndex}>
        {tabs.map(({label, icon}) => (
          <Tab key={label} label={label} iconLeading={icon} />
        ))}
      </TabsNavigation>
      <SelectedTabComponent />
    </div>
  )
}
